export function timeToTz(originalTime: number) {
  const currentUkraineTimeZone = originalTime + 3 * 60 * 60 * 1000
  const d = new Date(currentUkraineTimeZone)
  const utc = +Date.UTC(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
    d.getUTCSeconds(),
    d.getUTCMilliseconds()
  )
    .toString()
    .slice(0, -3)
  // console.log(console.log(originalTime, utc))
  return utc
}

export const timerByFilter = ({ isLastHour, isLast24H, timeIndex }: { isLastHour: boolean; isLast24H: boolean; timeIndex: number }) => {
  const hour = 1000 * 60 * 60
  const day = hour * 24
  const date = Date.now()
  if (isLastHour) {
    const hourDataPrev = new Date(date - hour * (timeIndex + 1))
    const hourData = new Date(date - hour * timeIndex)
    const days = hourData.toLocaleString('uk-UA').slice(0, 5)
    const hoursPrev = hourDataPrev.toLocaleString('uk-UA').slice(11, 17)
    const hours = hourData.toLocaleString('uk-UA').slice(11, 17)
    return `(${days}\xa0\xa0${hoursPrev} - ${hours})`
  }
  if (isLast24H) {
    const hourDataPrev = new Date(date - day * (timeIndex + 1))
    const hourData = new Date(date - day * timeIndex)
    const hours = hourData.toLocaleString('uk-UA').slice(11, 17)
    const daysPrev = hourDataPrev.toLocaleString('uk-UA').slice(0, 5)
    const days = hourData.toLocaleString('uk-UA').slice(0, 5)
    return `(${daysPrev} - ${days} \xa0 ${hours})`
  }
}
